<template>
  <div class="goods-analysis" v-loading="loading">
    <div>
      <div class="title">
        <span class="title-c">数据总览</span>每天0点左右更新前一日数据
      </div>
      <el-card class="box-card">
        <div class="data-count">
          <div class="data-item">
            <p>3天出货量</p>
            <p>{{ statData.DaysAmount }}</p>
          </div>
          <div class="data-item">
            <p>7天出货量</p>
            <p>{{ statData.WeekAmount }}</p>
          </div>
          <div class="data-item">
            <p>15天出货量</p>
            <p>{{ statData.TWeekAmount }}</p>
          </div>
          <div class="data-item">
            <p>30天出货量</p>
            <p>{{ statData.MonthAmount }}</p>
          </div>
          <div class="data-item">
            <p>年度出货量</p>
            <p>{{ statData.YearAmount }}</p>
          </div>
          <div class="data-item">
            <p>最长回货期</p>
            <p>
              {{
                statData.LBackPeriods > 0
                  ? (statData.LBackPeriods / 24).toFixed(1)
                  : "-"
              }}
            </p>
          </div>
          <div class="data-item border-right-none">
            <p>最短回货期</p>
            <p>
              {{
                statData.SBackPeriods > 0
                  ? (statData.SBackPeriods / 24).toFixed(1)
                  : "-"
              }}
            </p>
          </div>
        </div>
      </el-card>
      <div class="echart-ctn" id="echartStn"></div>
      <div class="toggle-year">
        <span>年份：</span>
        <el-date-picker
          value-format="yyyy"
          size="small"
          v-model="searchYearData.Year"
          type="year"
          placeholder="选择年"
          @change="searchYear"
          :picker-options="pickerOptions"
          style="width: 150px"
        ></el-date-picker>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["GoodsId","NoInit"],
  components: {},
  data() {
    return {
      loading: false,
      searchYearData: {
        GoodsId: "",
        Year: "",
      },
      date: [],
      series: [],
      statData: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    this.searchYearData.GoodsId = this.GoodsId;
    this.getBeforeYear();
    if (!this.NoInit)this.getData();
  },
  methods: {
    getBeforeYear() {
      let date = new Date();
      this.searchYearData.Year = date.getFullYear().toString();
    },
    searchYear() {
      this.getData();
    },
    // 更新表格数据
    updateTableData(id) {
      this.searchYearData.GoodsId = id;
      this.getData();
    },
    getData() {
      let that = this;
      that.loading = true;
      that.$util
        .axiosGet({
          url: "/api/EntpGoods/GoodsStatistics",
          data: this.searchYearData,
        })
        .then((res) => {
          this.date = [
            "1月份",
            "2月份",
            "3月份",
            "4月份",
            "5月份",
            "6月份",
            "7月份",
            "8月份",
            "9月份",
            "10月份",
            "11月份",
            "12" + "月份",
          ];
          let _series = [];
          let data = res.data.statB;
          this.statData = res.data.statA;
          for (let i = 0; i < data.length; i++) {
            _series.push({
              name: data[i].name,
              type: "line",
              data: data[i].data,
            });
          }
          this.series = _series;
          this.initEchart();
          that.loading = false;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    initEchart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("echartStn"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "销售采购数图",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.date,
        },
        yAxis: {
          type: "value",
        },
        series: this.series,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.data-count {
  padding: 15px;
  display: flex;
  .data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 13.8%;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
      margin-bottom: 10px;
    }
  }
}
.echart-ctn {
  height: 300px;
  margin-top: 20px;
}
.goods-analysis {
  position: relative;
}
.toggle-year {
  position: absolute;
  top: 136px;
  left: 140px;
}
.title {
  margin-left: 10px;
  margin-bottom: 10px;

  .title-c {
    font-size: 16px;
    font-weight: bold;
    color: black;
    margin-right: 10px;
  }
}
</style>
